import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import Popup from '../../components/common/ui/Popup/Popup';

import './index.css';

const TestingIntroPage = () => {
  const history = useHistory();

  let introText;

  if (localStorage.testingTypeId !== '3') {
    introText = (
      <>
        <p className="justify">Уважаемые ребята!</p>
        <p className="justify">
          В образовательных организациях Российской Федерации ежегодно
          проводится всероссийское тестирование социально-значимых характеристик
          личности современных школьников и студентов. Возможно, многие из вас
          уже принимали в нем участие.
        </p>
        <p className="justify">
          Тестирование предназначено для определения сильных сторон вашей
          личности, особенностей вашей реакции на различные жизненные
          обстоятельства и выбора поведения в них. Тест позволит определить
          степень вашей психологической устойчивости, поможет разобраться в
          себе, узнать о себе больше.
        </p>
        <p className="justify">
          Сегодня у вас будет возможность принять участие в таком тестировании.
          С вашей стороны важно желание пройти тест и искренне ответить на все
          вопросы.
        </p>
        <p className="justify">
          Психологические опросники не предполагают правильного (хорошего)
          ответа или неправильного (нехорошего). Любой ответ, который, на ваш
          взгляд, является верным, отражает вашу точку зрения, - является самым
          правильным.
        </p>
        <p className="justify">
          Если есть вопросы, задайте их до начала проведения тестирования.
        </p>
        <p className="justify">
          Вам будет предложен ряд утверждений. Внимательно прочитайте их,
          оценивая каждое утверждение как неверное или верное по отношению к
          вам, используя шкалу от 1 (утверждение абсолютно неверно) до 10
          (утверждение абсолютно верно).
        </p>
        <p className="justify">
          Вы можете проходить тест с комфортной для себя скоростью. Не стоит
          торопиться, но и не нужно долго думать над ответом на вопрос. Самый
          лучший вариант – первый, который «пришел в голову»
        </p>
      </>
    );
  } else {
    introText = (
      <>
        <p className="justify">Уважаемые студенты!</p>
        <p className="justify">
          В образовательных организациях Российской Федерации ежегодно
          проводится всероссийское тестирование социально-значимых характеристик
          личности современных школьников и студентов. Возможно, многие из вас
          уже принимали в нем участие.
        </p>
        <p className="justify">
          Тестирование предназначено для определения сильных сторон вашей
          личности, особенностей вашей реакции на различные жизненные
          обстоятельства и выбора поведения в них. Тест позволит определить
          степень вашей психологической устойчивости, поможет разобраться в
          себе, узнать о себе больше.
        </p>
        <p className="justify">
          Сегодня у вас будет возможность принять участие в таком тестировании.
          С вашей стороны важно желание пройти тест и искренне ответить на все
          вопросы.
        </p>
        <p className="justify">
          Психологические опросники не предполагают правильного (хорошего)
          ответа или неправильного (нехорошего). Любой ответ, который, на ваш
          взгляд, является верным, отражает вашу точку зрения, - является самым
          правильным.
        </p>
        <p className="justify">
          Если есть вопросы, задайте их до начала проведения тестирования.
        </p>
        <p className="justify">
          Вам будет предложен ряд утверждений. Внимательно прочитайте их,
          оценивая каждое утверждение как неверное или верное по отношению к
          вам, используя шкалу от 1 (утверждение абсолютно неверно) до 10
          (утверждение абсолютно верно).
        </p>
        <p className="justify">
          Вы можете проходить тест с комфортной для себя скоростью. Не стоит
          торопиться, но и не нужно долго думать над ответом на вопрос. Самый
          лучший вариант – первый, который «пришел в голову»
        </p>
      </>
    );
  }

  return (
    <Popup width="900px" height="auto">
      {introText}
      <br />
      <Button
        variant="primary"
        style={{ float: 'right', paddingLeft: '30px', paddingRight: '30px' }}
        onClick={() => {
          sessionStorage.seenIntro = true;
          history.push('/testing');
        }}
      >
        Далее
      </Button>
    </Popup>
  );
};

export default TestingIntroPage;
